export const CLIENTS_API = '/api/v1/clients';
